import React, { useMemo, useRef } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { isNil, round } from 'lodash';

import styles from './ConsistencyTooltip.module.scss';

interface Props {
  consistency: number | null;
  graphWidth: number;
  tooltipLeftPosition?: number;
}

const ConsistencyTooltip: React.FC<Props> = ({ consistency, graphWidth, tooltipLeftPosition }) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const positionStyles = useMemo(() => {
    const leftPosition = tooltipLeftPosition ?? 0;
    const tooltipWidth = tooltipRef?.current?.offsetWidth ?? 0;
    let leftVal = leftPosition;
    if (leftPosition > 25) leftVal = leftPosition - tooltipWidth / 2;
    if (graphWidth - leftPosition < 25) leftVal = leftPosition - tooltipWidth;
    return {
      left: `${leftVal}px`,
    };
  }, [graphWidth, tooltipLeftPosition]);

  const consistencyLabel = useMemo(() => {
    if (isNil(consistency)) {
      return '--';
    }
    return consistency < 10 ? round(consistency, 1) : round(consistency, 0);
  }, [consistency]);

  return (
    <Box
      className={styles.container}
      data-testid="wave-consistency-graph-tooltip"
      ref={tooltipRef}
      style={positionStyles}
    >
      <Grid data-testid="wave-consistency-reading" item>
        <Box className={styles.content}>
          <Grid container spacing={1} justifyContent="space-around">
            <Grid item mobile={12}>
              <Typography variant="callout1" component="span">
                {consistencyLabel}
                <Typography component="span" variant="callout2">
                  /100
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default ConsistencyTooltip;
